export function removeElementByIndex<T>(arr: T[], index: number): T[] {
  if (index < 0 || index >= arr.length) {
    throw new Error('Index out of range');
  }

  // Create a new array without the element at the specified index
  const newArr = [...arr.slice(0, index), ...arr.slice(index + 1)];

  return newArr;
}
